import React from 'react';
import PortfolioOptimizerTable from '../../PortfolioOptimizerTable';

export default function DashboardOptimizerSection({
    setConstraints,
    riskMetricsActPort,
    riskMetricsOptPort,
    riskMetricsDeltaPort,
    displayedExpectedReturnPolicy,
    maxSharpeSkill,
    setMaxSharpeSkill,
    errorOptimization,
    optimizerQueueState,
    cancelQueuedOptimization,
    setErrorOptimization,
    optimizerIsRunning,
    optimizerRunBlocker,
    runOptimization,
    metaOptimizer,
    constraints,
    gmvBudget,
    groupConstraints,
    setGroupConstraints,
    optimizerV2Capability,
    optimizerAttributeCatalog,
    handleWhatIfPortfolioChange,
    optimalPortfolioOptimizer,
    setOptimalPortfolioOptimizer,
    optimalPortfolioSummary,
    setOptimalPortfolioSummary,
    listOfWhatIfPortfolios,
    saveOptimizationAndWhatIfPortfolioData,
    constraintToggles,
    setConstraintToggles,
    showPortfolioMetrics,
    tickerData,
    setTickerData,
    objective,
    setObjective,
    fetchOptimizerPortfolios,
    setShowPortfolioMetrics,
    clearOptimizedOverlay,
    unsavedOptimizerRun,
    receiptDisplayActive,
    resultStale,
    detachOptimizerResult,
    resetOptimizerLimits,
    setOptimizedRiskMetrics,
    optStatus,
    viewMode,
    setViewMode,
    risksByFactor,
    constraintEvaluation,
    resultIssuedAt,
    solverStatus,
    factorNames,
    handleAddConstraint,
    handleRemoveConstraint,
    matricesLoading,
    viewModeLoading,
    finalTickerDataFlag,
    resetOptimizerDefaults,
    refreshSavedOptimizedPortfolio,
    posSizingSyncStatus,
    onSyncPosSizingDraft,
    posSizingOptimizerContextControl,
    onWatchlistRestorationStaged,
}) {
    return (
        <PortfolioOptimizerTable
            setConstraints={setConstraints}
            riskMetricsActPort={riskMetricsActPort}
            riskMetricsOptPort={riskMetricsOptPort}
            riskMetricsDeltaPort={riskMetricsDeltaPort}
            displayedExpectedReturnPolicy={displayedExpectedReturnPolicy}
            maxSharpeSkill={maxSharpeSkill}
            setMaxSharpeSkill={setMaxSharpeSkill}
            error={errorOptimization}
            optimizerQueueState={optimizerQueueState}
            cancelQueuedOptimization={cancelQueuedOptimization}
            setError={setErrorOptimization}
            optimizerIsRunning={optimizerIsRunning}
            optimizerRunBlocker={optimizerRunBlocker}
            runOptimization={runOptimization}
                    metaOptimizer={metaOptimizer}
            constraints={constraints}
            gmvBudget={gmvBudget}
            groupConstraints={groupConstraints}
            setGroupConstraints={setGroupConstraints}
            optimizerV2Capability={optimizerV2Capability}
            optimizerAttributeCatalog={optimizerAttributeCatalog}
            handleWhatIfPortfolioChange={handleWhatIfPortfolioChange}
            optimalPortfolioOptimizer={optimalPortfolioOptimizer}
            setOptimalPortfolioOptimizer={setOptimalPortfolioOptimizer}
            optimalPortfolioSummary={optimalPortfolioSummary}
            setOptimalPortfolioSummary={setOptimalPortfolioSummary}
            listOfWhatIfPortfolios={listOfWhatIfPortfolios}
            saveOptimizationAndWhatIfPortfolioData={saveOptimizationAndWhatIfPortfolioData}
            constraintToggles={constraintToggles}
            setConstraintToggles={setConstraintToggles}
            showPortfolioMetrics={showPortfolioMetrics}
            tickerData={tickerData}
            setTickerData={setTickerData}
            objective={objective}
            setObjective={setObjective}
            fetchOptimizerPortfolios={fetchOptimizerPortfolios}
            setErrorOptimization={setErrorOptimization}
            setShowPortfolioMetrics={setShowPortfolioMetrics}
            clearOptimizedOverlay={clearOptimizedOverlay}
            unsavedOptimizerRun={unsavedOptimizerRun}
            receiptDisplayActive={receiptDisplayActive}
            resultStale={resultStale}
            detachOptimizerResult={detachOptimizerResult}
            resetOptimizerLimits={resetOptimizerLimits}
            setOptimizedCalculations={setOptimizedRiskMetrics}
            optStatus={optStatus}
            viewMode={viewMode}
            setViewMode={setViewMode}
            risksByFactor={risksByFactor}
            constraintEvaluation={constraintEvaluation}
            resultIssuedAt={resultIssuedAt}
            solverStatus={solverStatus}
            factorNames={factorNames}
            handleAddConstraint={handleAddConstraint}
            handleRemoveConstraint={handleRemoveConstraint}
            matricesLoading={matricesLoading}
            viewModeLoading={viewModeLoading}
            finalTickerDataFlag={finalTickerDataFlag}
            resetOptimizerDefaults={resetOptimizerDefaults}
            refreshSavedOptimizedPortfolio={refreshSavedOptimizedPortfolio}
            posSizingSyncStatus={posSizingSyncStatus}
            onSyncPosSizingDraft={onSyncPosSizingDraft}
            posSizingContextControl={viewMode === 'pos-sizing'
                ? posSizingOptimizerContextControl
                : null}
            onWatchlistRestorationStaged={onWatchlistRestorationStaged}
        />
    );
}
